import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { EvaluationScreen } from '@/features/evaluations/evaluation-screen'

/**
 * `?edit=true` opens the wizard on arrival: a duplicate just made, to carry on with.
 * `?listing=<id>` is the listing open in the evidence sheet, so the back button closes it.
 */
const searchSchema = z.object({
  edit: z.boolean().optional().catch(undefined),
  listing: z.string().optional().catch(undefined),
})

/** One evaluation's page, reached from its row in the list. */
export const Route = createFileRoute('/_app/_org/evaluations/$evaluationId')({
  validateSearch: searchSchema,
  component: function EvaluationRoute() {
    const { evaluationId } = Route.useParams()
    const { edit } = Route.useSearch()
    return (
      <EvaluationScreen key={evaluationId} evaluationId={evaluationId} editing={edit === true} />
    )
  },
})
